<template>
  <v-app>
    <v-app-bar dense fixed clipped-left app color="primary" dark 
      extended :extension-height="4">
        <v-toolbar-title>{{this.$t('results.title')}} -&nbsp;</v-toolbar-title>
        <v-menu :nudge-width="100">
          <template v-slot:activator="{ on }">
          <v-toolbar-title v-on="on">
            <span v-if="$store.getters['competition']">{{ $store.getters['competition'].title }}</span>
            <v-icon>arrow_drop_down</v-icon>
          </v-toolbar-title>
          </template>

          <v-list>
            <v-list-item
              v-for="item in this.$store.getters['competitions']"
              :key="item.id"
              @click="selectCompetition(item)">
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-spacer></v-spacer>
        <v-menu :nudge-width="100">
          <template v-slot:activator="{ on }">
            <v-toolbar-title v-on="on">
              <span><flag :iso="localeCountry" /></span>
              <v-icon>arrow_drop_down</v-icon>
            </v-toolbar-title>
          </template>

          <v-list>
            <v-list-item
              v-for="item in Object.keys(this.$i18n.messages)"
              :key="item"
              @click="changeLocale(item)">
              <v-list-item-title><flag :iso="item | localeToCountry" /> {{ $t('langNative.'+item) }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        
        <v-progress-linear v-if="$store.getters['loading']" slot="extension" :indeterminate="true" class="ma-0" color="accent" :height="4"></v-progress-linear>  
    </v-app-bar>
    <v-content>
      <Results v-if="$store.getters['competition']" />
    </v-content>
  </v-app>
</template>

<script>
import {
    VCard,
    VCardActions,
    VCardTitle,
    VCardText,
    VMenu,
    VSelect,
    VProgressLinear
} from 'vuetify/lib'
import Results from './views/Results.vue'

export default {
  name: 'ResultsPage',
  data () {
    return {
      drawer: true,
      fixed: false,
      right: true,
      rightDrawer: false,
      competitions: null
    }
  },
  computed: {
    competitionNames: function() {
      return this.$store.getters['competitions'].map(c => c.title);
    },
    localeCountry: function() {
      return this.$i18n.locale.split('-')[1]
    },
    selectedCompetition: {
      set(id) {
        this.$store.dispatch('selectCompetition', id);
      },
      get(){
        return this.$store.getters['competitionId'];
      }
    },
    competitionsList: function(){
      return this.$store.getters['competitions'] || [];
    },
    competitionsLoaded: function() {
      return this.competitions != null;
    }
  },
  methods: {
    changeLocale(locale){
      this.$i18n.locale = locale
    },
    closeErrorDialog(){
      this.$store.dispatch('reportError', null)
    },
    selectCompetition: function(c){
      this.$store.dispatch('selectCompetition', c.id);
    }
  },
  mounted: function(){
    this.$store.dispatch('loadCompetitions').then(rr => {

    })
  },
  components: {
    VSelect,
    VMenu,
    VCard,
    VCardActions,
    VCardText,
    Results,
    "v-progress-linear": VProgressLinear
  }
}
</script>
